<template>
  <v-dialog
    v-model="localDialog"
    width="70%"
    @update:modelValue="updateDialog"
    transition=""
    persistent
    :open-delay="0"
    :close-delay="0"
  >
    <v-card>
      <v-card-title class="text-h6">
        <span class="text-center">SI Collection</span>
      </v-card-title>

      <v-divider></v-divider>

      <v-card-text>
        <v-row>
          <v-col cols="6">
            <v-table class="bg-purple-lighten-5" density="compact">
              <thead>
                <tr>
                  <th colspan="2" class="text-left">
                    Collection Summary
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Invoice No.</td>
                  <td>{{ code }}</td>
                </tr>
                <tr>
                  <td>Total </td>
                  <td>{{ total }}</td>
                </tr>
                <tr>
                  <td>Net Collected </td>
                  <td>{{ collected_amount = collections.reduce((prev, curr) => { return +prev + +curr.net_collection }, 0) }}</td>
                </tr>
                <tr>
                  <td>Discount </td>
                  <td>{{ collected_amount = collections.reduce((prev, curr) => { return +prev + +curr.discount }, 0) }}</td>
                </tr>
                <tr>
                  <td>Total Collected </td>
                  <td>{{ collected_amount = collections.reduce((prev, curr) => { return +prev + +curr.amount }, 0) }}</td>
                </tr>
                <!-- <tr>
                  <td>Advance Payment</td>
                  <td>{{ paid }}</td>
                </tr> -->
                <tr>
                  <td>Due </td>
                  <td>{{ due }}</td>
                </tr>
                
              </tbody>
            </v-table>

            <v-table class=" mt-2" density="compact">
              <thead>
                <tr>
                  <th colspan="5" class="text-left">
                    Transaction Records
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th>Collection Date</th>
                  <td>Collection Type</td>
                  <td>Net Collection</td>
                  <td>Discount</td>
                  <td>Total</td>
                </tr>
                <tr v-for="item in collections" :key="item">
                  <td>{{ item.payment_date }}</td>
                  <td>{{ item.payment_type }}</td>
                  <td>{{ item.net_collection }}</td>
                  <td>{{ item.discount }}</td>
                  <td>{{ item.amount }}</td>
                </tr>
              </tbody>
            </v-table>
          </v-col>
          <v-col cols="6">
            <v-form @submit.prevent="submit" ref="PoPaymentSetup">
              <v-row>
                <v-col cols="6">     
                  <v-date-input
                    prepend-icon=""
                    prepend-inner-icon="mdi-calendar"
                    density="compact"
                    variant="outlined"
                    bg-color="grey-lighten-4"
                    v-model="payment_date.value.value"
                    :error-messages="payment_date.errorMessage.value"
                    hide-details="auto"
                    autocomplete="off"
                    clearable
                  >
                    <template #label>
                      Collection Date
                      <span class="text-red-accent-4">*</span>
                    </template>
                  </v-date-input>
                </v-col>

                <v-col cols="6">
                  <v-select 
                    variant="outlined" 
                    density="compact"
                    bg-color="grey-lighten-4"
                    v-model="payment_type.value.value" 
                    :items="paymentTypes"
                    :item-title="(item) => `${item.label}`"
                    item-value="value" 
                    :error-messages="payment_type.errorMessage.value"
                    @update:modelValue="onPaymentTypeChange"
                    hide-details="auto"
                    autocomplete="off"
                  >
                    <template #label>
                      Collection Type
                      <span class="text-red-accent-4">*</span>
                    </template>
                  </v-select>
                </v-col>

                <v-col cols="12">
                    <v-select 
                      label="Account No"
                      variant="outlined" 
                      density="compact"
                      bg-color="grey-lighten-4"
                      v-model="payment_acc_head.value.value"
                      :items="getPaymentAccountHeadList"
                      :item-title="(item) => `${item.name}`"
                      item-value="id" 
                      hide-details="auto"
                      :error-messages="payment_acc_head.errorMessage.value"
                      autocomplete="off"
                    />
                </v-col>

                <v-col v-if="payment_type.value.value === 'BANK'" cols="6">
                  <v-text-field 
                    label="Cheque No" 
                    density="compact"
                    type="number"
                    variant="outlined" 
                    bg-color="grey-lighten-4"
                    v-model="chequeNo.value.value"
                    hide-details="auto"
                    :error-messages="chequeNo.errorMessage.value"
                    autocomplete="off" 
                  />
                </v-col>

                <v-col v-if="payment_type.value.value === 'BANK'" cols="6">
                  <v-date-input 
                      label="Cheque Issue Date"
                      density="compact"
                      bg-color="grey-lighten-4"
                      prepend-icon="" 
                      prepend-inner-icon="mdi-calendar"
                      v-model="cheque_issue_date.value.value" 
                      variant="outlined"
                      hide-details="auto"
                      :error-messages="cheque_issue_date.errorMessage.value"
                      autocomplete="off"
                  ></v-date-input>
                </v-col>

                <v-col v-if="payment_type.value.value === 'MOBILE_BANKING'" cols="6">
                  <v-autocomplete 
                    density="compact" 
                    variant="outlined"
                    bg-color="grey-lighten-4"
                    label="Provider"
                    v-model="mobileProvider.value.value"
                    :items="mobileProviders"
                    item-title="label"
                    item-value="value" 
                    hide-details="auto"
                    :error-messages="mobileProvider.errorMessage.value"
                    autocomplete="off"
                  >
                  </v-autocomplete>
                </v-col>

                <v-col v-if="payment_type.value.value === 'MOBILE_BANKING'" cols="6">
                  <v-text-field
                    density="compact"
                    variant="outlined" 
                    bg-color="grey-lighten-4"
                    label="Transaction ID"
                    v-model="transactionId.value.value"
                    hide-details="auto"
                    :error-messages="transactionId.errorMessage.value"
                    autocomplete="off" 
                  />
                </v-col>

                <v-col cols="6" md="6">
                  <v-text-field 
                    label="Amount"
                    density="compact" 
                    variant="outlined" 
                    type="number"
                    bg-color="grey-lighten-4"
                    v-model="amount.value.value"
                    @update:model-value="paymentCalculate"
                    hide-details="auto"
                    :error-messages="amount.errorMessage.value"
                    autocomplete="off"
                  >
                  </v-text-field>
                </v-col>

                <v-col cols="6" md="6">
                  <v-text-field 
                    label="Discount" 
                    density="compact"
                    variant="outlined" 
                    type="number"
                    bg-color="grey-lighten-4"
                    v-model="discount.value.value"
                    :error-messages="discount.errorMessage.value"
                    @update:model-value="paymentCalculate"
                    hide-details="auto"
                    autocomplete="off"
                  >
                  </v-text-field>
                </v-col>

                <v-col cols="12" md="12">
                  <v-text-field 
                    density="compact" 
                    variant="outlined" 
                    bg-color="grey-lighten-4"
                    type="number"
                    v-model="net_collection.value.value"
                    :error-messages="net_collection.errorMessage.value"
                    hide-details="auto"
                    autocomplete="off"
                    readonly
                  >
                    <template #label>
                      Net Collection
                      <span class="text-red-accent-4">*</span>
                    </template>
                  </v-text-field>
                </v-col>

                <v-col cols="12" md="12">
                  <v-date-input 
                    label="Next Payment Date"
                    density="compact" 
                    variant="outlined" 
                    bg-color="grey-lighten-4"
                    prepend-icon="" 
                    prepend-inner-icon="mdi-calendar"
                    v-model="next_payment_date.value.value"
                    :error-messages="next_payment_date.errorMessage.value"
                    hide-details="auto"
                    autocomplete="off"
                  >
                    <template #label>
                      Next Payment Date
                    </template>
                  </v-date-input>
                </v-col>

                <v-col cols="12" md="12">
                  <v-textarea 
                    label="Description" 
                    density="compact" 
                    variant="outlined"
                    bg-color="grey-lighten-4" 
                    v-model="description.value.value"
                    :error-messages="description.errorMessage.value" 
                    autocomplete="off"
                    rows="3" 
                    hide-details="auto"
                    clearable
                  >
                  </v-textarea>
                </v-col>
              </v-row>
              <v-divider></v-divider>
              <v-card-actions>
                <v-layout class="justify-end">
                  <v-btn
                    class="bg-red"
                    variant="flat"
                    type="reset"
                    @click="closeDialog"
                  >Close</v-btn>
                  <v-btn class="bg-brand w-15 ms-2" variant="flat" type="submit">Save</v-btn>
                </v-layout>
              </v-card-actions>
            </v-form>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { ref, watch } from "vue";
import { useStore } from "vuex";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { toast } from "vue3-toastify";
import formattedDate from "@/plugins/dateFormatter";
import axios from "axios";
import { getCustomerPaymentById } from "@/store/api";


export default {
  name: "DailyUpdateSetup",
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: () => ({
        status: "1",
      }),
    },
  },
  emits: ['update:dialog'],
  data() {
    return {
      localDialog: this.dialog,
      selectedImage: null,
      errorMessages: "",
      loading: false,
      code: '',
      total: '',
      paid: '',
      due: '',
      collected_amount: '',
      paymentTypes: [
        { label: "Cash", value: "CASH" },
        { label: "Bank", value: "BANK" },
        { label: "Mobile Banking", value: "MOBILE_BANKING" }
      ],
      mobileProviders: [
        { label: "Bkash", value: "bkash" },
        { label: "Nagad", value: "nagad" },
        { label: "Rocket", value: "rocket" }
      ],
      collections: []
    };
  },
  watch: {
    dialog(val) {
      this.localDialog = val;
    },
    localDialog(val) {
      this.$emit("update:dialog", val);
    },
    data: {
      handler(newData) {
        console.log(newData);
        this.resetForm({ errors: {}, touched: {} });
        this.status.setValue(String(newData.status) || "1", false);
        this.sale_invoice_id.setValue(newData.id || "", false);
        this.sale_order_id.setValue(newData.sale_order_id || "", false);
        this.customer_id.setValue(newData.customer_id || "", false);
        this.amount.setValue(newData.due_amount || 0, false);
        this.code = newData.code;
        this.total = newData.total;
        this.paid = newData.paid;
        this.due = newData.due_amount;
        this.collected_amount = 0;
        this.payment_date.setValue(new Date(), false);
        this.next_payment_date.setValue(new Date(), false);
        this.currency_rate.setValue(newData.currency_rate || 0, false);
        this.rate_id.setValue(newData.rate_id || 0, false);
        if (this.sale_invoice_id && this.sale_invoice_id.value && this.sale_invoice_id.value.value) {
          this.getCustomerPayments(this.sale_invoice_id.value.value);
        }
      },
    },
  },
  created() {
    // if (this.$store.getters.getSalesLeadInterest.length === 0) {
    //   this.$store.dispatch("getSalesLeadInterest");
    // }
  },
  computed: {
      getPaymentAccountHeadList() {
        return this.$store.getters.getPaymentAccountHeadList;
      },
   
  },
  methods: {
    async onPaymentTypeChange() {
      if (this.payment_type.value.value) {
        await this.$store.dispatch("getPaymentAccountHeadList", { type: this.payment_type.value.value });
        this.payment_acc_head.value.value = null;
      }
    },
    paymentCalculate() {
      const amount = parseFloat(this.amount.value.value) || 0;
      const discount = parseFloat(this.discount.value.value) || 0;
      const netCollection = parseFloat(+amount - +discount);
      this.net_collection.value.value = Number(netCollection.toFixed(2));
    },
    async getCustomerPayments(id) {
      axios.get(getCustomerPaymentById + '/' + id).then((response) => {
        const data = response.data.data;
        console.log(data);
        this.collections = data;
      })
      .catch((error) => {
        commit("UNSET_SALE_INVOICE_LIST");
        reject(error);
      })
    },
    updateDialog(val) {
      this.$emit("update:dialog", val);
    },
    closeDialog() {
      this.$emit("update:dialog", false);
    },
  },
  setup(props, { emit }) {
    const { handleSubmit, resetForm } = useForm({
      validationSchema: yup.object({
        sale_invoice_id: yup.number().required().label("Sale Invoice No"),
        payment_date: yup.date().required().label("Payment Date"),
        payment_type: yup.string().required().label("Payment Type"),
        amount: yup.number().required().label("Amount"),
        discount: yup.number().nullable().label("Discount"),
        net_collection: yup.number().required().label("Discount"),
        next_payment_date: yup.date().required().label("Next Payment Date"), 
        payment_acc_head: yup.number().required().label("Payment Account Head"),
        chequeNo: yup.string().nullable().when("payment_type", { is: "BANK", then: (schema) => schema.required("Cheque No is required"),  otherwise: (schema) => schema.nullable(),}),
        cheque_issue_date: yup.date().nullable().when("payment_type", { is: "BANK", then: (schema) => schema.required("Cheque Issue Date is required"),  otherwise: (schema) => schema.nullable(),}),
        mobileProvider: yup.string().nullable().when("payment_type", { is: "MOBILE_BANKING", then: (schema) => schema.required("Provider is required"),  otherwise: (schema) => schema.nullable(),}),
        transactionId: yup.string().nullable().when("payment_type", { is: "MOBILE_BANKING",  then: (schema) => schema.required("Transaction ID is required"), otherwise: (schema) => schema.nullable(),}),
        status: yup.string().required().label("Status"),
      }),
    });
    const sale_invoice_id = useField("sale_invoice_id");
    const sale_order_id = useField("sale_order_id");
    const customer_id = useField("customer_id");
    const payment_date = useField("payment_date");
    const payment_type = useField("payment_type");
    const payment_acc_head = useField("payment_acc_head");
    const amount = useField("amount");
    const discount = useField("discount");
    const net_collection = useField("net_collection");
    const chequeNo = useField("chequeNo");
    const cheque_issue_date = useField("cheque_issue_date");
    const transactionId = useField("transactionId");
    const mobileProvider = useField("mobileProvider");
    const next_payment_date = useField("next_payment_date");
    const rate_id = useField("rate_id");
    const currency_rate = useField("currency_rate");
    const description = useField("description");

    const status = useField("status");
    const errorMessages = ref("");
    const loading = ref("");
    const store = useStore();

    const submit = handleSubmit((values) => {
      values.payment_date = payment_date.value.value ? formattedDate(payment_date.value.value) : null;
      values.cheque_issue_date = cheque_issue_date.value.value ? formattedDate(cheque_issue_date.value.value) : null;
      values.next_payment_date = next_payment_date.value.value ? formattedDate(next_payment_date.value.value) : null;
      const formData = new FormData();
      Object.keys(values).forEach((key) => {
        formData.append(key, values[key] || "");
      });
      console.log(formData)
      store
        .dispatch("saveCustomerPayment", formData)
        .then((response) => {
          resetForm();
          emit("update:dialog", false);
          emit("update-success");
          toast.success(response.data.message);
          loading.value = true;
          Promise.all([
            store.dispatch("getSaleInvoiceList"),
            // store.dispatch("getSalesInvoiceById", sale_invoice_id),
          ]).finally(() => {
            loading.value = false;
          });
        })
        .catch((error) => {
          console.log(error.response)
          toast.error(error.response?.data?.message);
        });
    });
    return {
      submit,
      sale_invoice_id,
      sale_order_id,
      customer_id,
      payment_date,
      payment_type,
      payment_acc_head,
      amount,
      discount,
      net_collection,
      chequeNo,
      cheque_issue_date,
      transactionId,
      mobileProvider,
      description,
      next_payment_date,
      rate_id,
      currency_rate,
      errorMessages,
      resetForm,
      status,
      loading,
    }
  },
  mounted() {
    this.amount.value.value = 0
    this.discount.value.value = 0
    this.status.value.value = 1;
    this.payment_date.value.value = new Date();
    this.next_payment_date.value.value = new Date();
  },
};
</script>
